<script setup>
import { APPEARANCE_OPTIONS, useAppearance } from '@/composables/useAppearance';

// The starter kit's appearance tabs: Light / Dark / System as a segmented
// control. Applies immediately.
const { mode, setMode } = useAppearance();
</script>

<template>
  <div class="toggle" role="radiogroup" aria-label="Appearance">
    <button
      v-for="option in APPEARANCE_OPTIONS"
      :key="option.value"
      type="button"
      role="radio"
      class="toggle__item"
      :class="{ 'toggle__item--active': mode === option.value }"
      :aria-checked="mode === option.value"
      @click="setMode(option.value)"
    >
      <v-icon size="16">{{ option.icon }}</v-icon>
      {{ option.title }}
    </button>
  </div>
</template>

<style scoped>
.toggle {
  display: inline-flex;
  gap: 4px;
  padding: 4px;
  border-radius: 10px;
  background: var(--accent);
}
.toggle__item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 14px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--muted-foreground);
  font: inherit;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.toggle__item:hover {
  color: var(--foreground);
}
.toggle__item--active {
  background: var(--background);
  color: var(--foreground);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
}
.toggle__item:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(var(--brand-rgb), 0.3);
}
</style>
